import React, { useRef, useState } from "react";
import { Whisper, Popover } from "rsuite";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AddPaymentModal from "../pharmacy/pharmacymodels/AddPaymentModal";
const ActionCellPayment = ({ data, onDelete, onEditPayment }) => {
  const triggerRef = useRef(null);
  const navigate = useNavigate();

  const handleEditInvoice = () => {
    onEditPayment(data);
if (triggerRef.current) triggerRef.current.close();

    if (triggerRef.current) triggerRef.current.close();
  };

  const handleDeleteInvoice = () => {
    if (window.confirm("Are you sure you want to delete this invoice?")) {
      onDelete(data.id);
      if (triggerRef.current) triggerRef.current.close();
    }
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-44">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      {/* ---- Edit ---- */}
      <div
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
        onClick={handleEditInvoice}
      >
        <MdOutlineEdit className="text-lg text-gray-500" />
        <span>Edit</span>
      </div>

      {/* ---- Delete ---- */}
      <div
        className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-red-50 rounded-md"
        onClick={handleDeleteInvoice}
      >
        <RiDeleteBin6Line className="text-lg text-red-500" />
        <span>Delete</span>
      </div>
    </Popover>
  );

  return (
    <Whisper
      ref={triggerRef}
      placement="topEnd"
      trigger="click"
      speaker={renderPopover}
    >
      <button
        className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        {/* 3 dots icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>
      </button>

    </Whisper>
  );
};

export default ActionCellPayment;
